import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ContactMessageService } from 'src/app/services/contactMessage.service';
import { ContactMessage } from 'src/app/models/contactMessage.model';

import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})

export class ContactComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////
  // INIT PARAM ////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////

  // FORM PARAM ////////////////////////////////////////////////////////

  contactMessageForm: FormGroup;
  triedSubmition = false;
  submitedMessage = false;


  // CAPTCHA PARAM /////////////////////////////////////////////////////

  public readonly siteKey = '6LeoxbQUAAAAAAIjavocdbIEvC4d-XY1bviY7efP';
  
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  public theme = 'light';
  public size = 'normal';
  public lang = 'fr';
  public type = 'image' ;
  public useGlobalDomain = false ;


  //////////////////////////////////////////////////////////////////////
  // CONSTRUCT PAGE ////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////

  constructor(private formBuilder: FormBuilder,
    private contactMessageService: ContactMessageService,
    private datePipe: DatePipe,
    private router: Router) { }

  ngOnInit() {
    window.scrollTo(0,0);
    this.initForm();
  }
  

  //////////////////////////////////////////////////////////////////////
  // FUNCTION DEFINTION ////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////

  // FORM FUNCTION /////////////////////////////////////////////////////

  initForm() {
    this.contactMessageForm = this.formBuilder.group({
      name:           ['',[Validators.required]],
      email:          ['',[Validators.required, Validators.email]],
      confirmEmail:   ['',[Validators.required, Validators.email]],
      phoneNumber:    [''],
      dateEvent:      [''], 
      message:        [''],
      recaptcha:      ['',[Validators.required]]
    })
  }

  onSubmitContactMessage() {
    this.triedSubmition = true;
  
    const name =          this.contactMessageForm.get('name').value;
    const email =         this.contactMessageForm.get('email').value;
    const confirmEmail =  this.contactMessageForm.get('confirmEmail').value;
    const phoneNumber =   this.contactMessageForm.get('phoneNumber').value;
    const dateEvent =     this.contactMessageForm.get('dateEvent').value;
    const message =       this.contactMessageForm.get('message').value;
    
    if(this.contactMessageForm.status === "VALID" && email === confirmEmail){
      const newContactMessage = new ContactMessage(name, email, phoneNumber, dateEvent, message);
      this.contactMessageService.saveContactMessage(newContactMessage);

      // afficher la confirmation de l'envoie 
      this.submitedMessage =  true;
      window.scrollTo(0,0);
    }
  }


  // CAPTCHA FUNCTION //////////////////////////////////////////////////

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
    //this.cdr.detectChanges();
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
  }


  // OTHER FUNCTION ////////////////////////////////////////////////////

  onCurentDate(){
    let curentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    return curentDate
  }

  onDeletPaste(){
    alert("Pas de copier coller pour ce champ, merci ;) !");
    return false;
  }

}
